var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-row',[_c('v-col',[_c('DocumentPOSAgainHead')],1)],1),_c('v-row',[_c('v-col',[_c('DocumentPOSAgainItems')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }